import React from "react";

const TermsAndConditions = () => {
  return (
    <div>
      <article>
        <header>
          <h1>Terms and Conditions</h1>
        </header>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By using Settl's services, you agree to comply with and be bound by
            these Terms and Conditions.
          </p>
        </section>

        <section>
          <h2>2. User Responsibilities</h2>
          <p>
            You are responsible for maintaining the confidentiality of your
            account and password and for restricting access to your account.
          </p>
        </section>

        <section>
          <h2>3. Prohibited Conduct</h2>
          <p>
            You shall not engage in any conduct that, in our sole discretion,
            restricts or inhibits any other user from using or enjoying the
            services.
          </p>
        </section>

        <section>
          <h2>4. Limitation of Liability</h2>
          <p>
            We shall not be liable for any indirect, incidental, special,
            consequential, or punitive damages, or any loss of profits or
            revenues.
          </p>
        </section>

        <section>
          <h2>5. Governing Law</h2>
          <p>
            These Terms and Conditions are governed by and construed in
            accordance with the laws of [Your Jurisdiction].
          </p>
        </section>

        <section>
          <h2>6. Changes to Terms</h2>
          <p>
            We reserve the right to change these Terms and Conditions at any
            time. Updated terms will be effective upon posting.
          </p>
        </section>

        <section>
          <h2>Contact Information</h2>
          <p>
            If you have any questions about these Terms and Conditions, please
            contact us at:
          </p>
        </section>
      </article>
    </div>
  );
};

export default TermsAndConditions;
